import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaDiscord } from 'react-icons/fa';
import { CURRENT_VERSION } from '../../config/version';
import FeedbackModal from './FeedbackModal';
import BugReportModal from './BugReportModal';
import './Footer.scss';

const Footer = () => {
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [showBugReportModal, setShowBugReportModal] = useState(false);

  const currentYear = new Date().getFullYear();

  const handleFeedbackClick = () => {
    setShowFeedbackModal(true);
  };

  const handleCloseFeedback = () => {
    setShowFeedbackModal(false);
  };

  const handleBugReportClick = () => {
    setShowBugReportModal(true);
  };

  const handleCloseBugReport = () => {
    setShowBugReportModal(false);
  };

  return (
    <>
      <footer className="footer">
        <div className="footer__container">
          {/* Quick Links Section */}
          <div className="footer__section">
            <h3 className="footer__title">Games</h3>
            <ul className="footer__links">
              <li><Link to="/solve/slay-the-spire" className="footer__link">Slay the Spire</Link></li>
              <li><Link to="/solve/bible-books" className="footer__link">Bible Books</Link></li>
              <li><Link to="/solve/subnautica-creatures" className="footer__link">Subnautica Creatures</Link></li>
              <li><Link to="/solve/aoe2-units" className="footer__link">AoE2 Units</Link></li>
            </ul>
          </div>

          {/* Quick Links Section */}
          <div className="footer__section">
            <h3 className="footer__title">Features</h3>
            <ul className="footer__links">
              <li><Link to="/daily" className="footer__link">Daily Challenges</Link></li>
              <li><Link to="/leaderboard" className="footer__link">Leaderboard</Link></li>
              <li><Link to="/achievements" className="footer__link">Achievements</Link></li>
              <li><Link to="/stats" className="footer__link">Stats</Link></li>
            </ul>
          </div>

          {/* Support Section */}
          <div className="footer__section">
            <h3 className="footer__title">Support</h3>
            <ul className="footer__links">
              <li>
                <button 
                  onClick={handleFeedbackClick}
                  className="footer__link footer__link--button"
                >
                  Submit Feedback
                </button>
              </li>
              <li>
                <button 
                  onClick={handleBugReportClick}
                  className="footer__link footer__link--button"
                >
                  Report Bug
                </button>
              </li>
              <li><Link to="/updates" className="footer__link">Updates</Link></li>
              <li><Link to="/credits" className="footer__link">Credits</Link></li>
            </ul>
          </div>

          {/* Social Media Section */}
          <div className="footer__section">
            <h3 className="footer__title">Community</h3>
            <ul className="footer__links">
              <li>
                <a 
                  href="https://x.com/GuessNexus" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="footer__link footer__link--external"
                >
                  <span className="footer__social-icon">𝕏</span>
                  Twitter/X
                </a>
              </li>
              <li>
                <a 
                  href="https://discord.gg/VqhQUk7spC" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="footer__link footer__link--external"
                >
                  <FaDiscord className="footer__social-icon" />
                  Discord
                </a>
              </li>
            </ul>
          </div>

          {/* Legal Section */}
          <div className="footer__section">
            <h3 className="footer__title">Legal</h3>
            <ul className="footer__links">
              <li><Link to="/privacy" className="footer__link">Privacy Policy</Link></li>
              <li><Link to="/terms" className="footer__link">Terms of Service</Link></li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer__bottom">
          <div className="footer__bottom-container">
            <div className="footer__copyright">
              © {currentYear} GuessNexus. All rights reserved.
            </div>
            <div className="footer__version">
              v{CURRENT_VERSION}
            </div>
          </div>
        </div>
      </footer>

      <FeedbackModal 
        isOpen={showFeedbackModal}
        onClose={handleCloseFeedback}
      />
      
      <BugReportModal 
        isOpen={showBugReportModal}
        onClose={handleCloseBugReport}
      />
    </>
  );
};

export default Footer;